import { Icon } from "components/common";
import { DRAG_BAR_HEIGHT_REM } from "components/common/BottomSheet";
import { useEffect, useState } from "react";

type ProfileImageProps = {
  userInfo: UserInfo;
  category?: string;
  isPrime?: boolean;
};

const ProfileImage = ({ userInfo, category = 'profile', isPrime = false }: ProfileImageProps) => {
  const isTeamBermuda = userInfo?.fbUid === PageLogin.fbIdBermuda;
  const [imgUrl, setImgUrl] = useState<string | null>(null);
  const videoUrl = isPrime && userInfo ? PhotoManager.getPrimeVideoURL(userInfo) : null;
  const imageHeight = isPrime ? 'min(calc(100dvw * 4 / 3), 70dvh)' : 'min(100dvw, 70dvh)';

  useEffect(() => {
    if (!userInfo) return;

    if (isPrime) {
      setImgUrl(PhotoManager.getPrimePhotoURL(userInfo, true));
      return;
    }

    const lowResUrl = PhotoManager.getPhotoURL(userInfo, false);
    const highResUrl = PhotoManager.getPhotoURL(userInfo, true);

    setImgUrl(lowResUrl);

    const img = new Image();
    img.onload = () => {
      setImgUrl(highResUrl);
    };
    img.src = highResUrl;
  }, [userInfo, isPrime]);

  const handleReport = () => {
    ReportManager.show(
      { ...userInfo, uid: userInfo.fbUid },
      {
        entry: category,
        deleteCallback: () => {},
      }
    );
  };

  const handleGuide = () => {
    const isKo = BResource.getSelectedLocale() === 'ko';
    const guideLink = `https://www.thebermuda.net/communityguide-${isKo ? 'ko' : 'en-us'}.html`;
    const guidTitle = isKo ? '커뮤니티 가이드' : 'Community Guide';

    Transition.showPage(Def.PAGE_IFRAME, { title: guidTitle, url: guideLink });
  };

  return (
    // 너비는 시트 폭에 맞추고(좌우 1rem 패딩까지 블리드), 높이는 세로 화면에선 정사각형(프라임은 4:3), 가로 화면처럼 낮은 뷰포트에선 70dvh로 제한.
    // 시트가 70vw인 가로 모드에서 100dvw 정사각형이 시트를 넘쳐 깨져 보이던 문제 대응. 사진은 cover로 중앙 크롭.
    <div data-component="ProfileImage" className="w-[calc(100%+2rem)] overflow-hidden rounded-lg" style={{ height: imageHeight, marginTop: `-${DRAG_BAR_HEIGHT_REM}rem`, marginInline: '-1rem' }}>
      {userInfo && (
        <div className="relative h-full w-full">
          {videoUrl ? (
            <video className="h-full w-full object-cover" src={videoUrl} poster={imgUrl ?? undefined} autoPlay loop muted playsInline />
          ) : (
            imgUrl && <img className="h-full w-full object-cover" alt="" src={imgUrl} />
          )}
          <div className="absolute bottom-0 left-0 right-0 h-[25%] w-full" style={{ background: 'linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.50) 100%)' }} />
          <div className="absolute left-0 right-0 top-0 h-[25%] w-full" style={{ background: 'linear-gradient(180deg, rgba(0, 0, 0, 0.50) 0%, rgba(0, 0, 0, 0.00) 100%)' }} />
        </div>
      )}
      {userInfo && !isTeamBermuda && (
        <div className="icon-group-cont absolute top-4" style={{ insetInlineEnd: '0rem', direction: BResource.isRTL() ? 'rtl' : 'ltr' }}>
          {userInfo.fbUid !== myinfo.fbUid && <Icon name="icon/ic_report.svg" color="filter-base-ic-white" size={24} onClick={handleReport} />}
          {userInfo.fbUid === myinfo.fbUid && <Icon name="icon/ic_guide.svg" color="filter-base-ic-white" size={24} onClick={handleGuide} />}
        </div>
      )}
    </div>
  );
};

export default ProfileImage;
